<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.polls', 2),
                        href: meta.links.polls_index,
                    },
                    {
                        name: smileyPollQuestion.question,
                        href: meta.links.polls_show,
                    },
                    {
                        name: group.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <form action="" method="post" @submit.prevent="submit">
            <div>
                <div>{{ $tc('messages.votes', total) }}: {{ total }}</div>
                <div class="md:w-1/2 grid grid-cols-2 md:grid-cols-4 md:gap-6">
                    <button
                        type="button"
                        v-for="i in 4"
                        @click="form[`option_${i}`] += 1"
                        class="inline-block p-5"
                        :key="i"
                    >
                        <SmileyPollEmojiImage :number="i" class="h-auto md:h-28 w-full md:w-28" />
                    </button>
                </div>
            </div>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import SmileyPollEmojiImage from '@/components/SmileyPollEmojiImage.vue';

export default {
    components: {
        SmileyPollEmojiImage,
        SubmitFormButton,
        PanelPage,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'smileyPollResults', 'smileyPollQuestion', 'group'],
    data() {
        return {
            form: this.$inertia.form({
                option_1: 0,
                option_2: 0,
                option_3: 0,
                option_4: 0,
            }),
        };
    },
    computed: {
        total() {
            return this.form.option_1 + this.form.option_2 + this.form.option_3 + this.form.option_4;
        },
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
